export const TITLE = "Title";
export const TEXTBOX = "TextBox";
export const TEXTAREA = "TextArea";
export const SELECT = "Dropdown";